import script from "./OpenAppButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenAppButton.vue?vue&type=script&lang=ts&setup=true"

import "./OpenAppButton.vue?vue&type=style&index=0&id=14bfa349&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14bfa349"]])

export default __exports__